import { Link } from "react-router-dom";
import CONSTANTS from "../constants/constants";
import { getCandidateProfileSearch } from "./reusableFunctions";

const {
  PAGE_ROUTES: { CANDIDATE_PROFILE_ROUTE, SITE_PROFILE_ROUTE }
} = CONSTANTS;

export const CreateCandidatePageLink = props => {
  const {
    personObjectId = "",
    candidateObjectId = "",
    candidateName = "",
    mode = "",
    from = "",
    section = "",
    step = "",
    panel = "",
    pathname = CANDIDATE_PROFILE_ROUTE,
    children,
    replace = false,
    target = "_self",
    rel = "",
    onClick = () => {}
  } = props;

  return (
    <Link
      to={{
        pathname,
        search: getCandidateProfileSearch("", {
          params: JSON.stringify({
            personObjectId,
            candidateObjectId,
            candidateName,
            mode,
            from
          }),
          section,
          step,
          panel
        })
      }}
      replace={replace}
      target={target}
      rel={rel}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export const CreateSitePageLink = props => {
  const {
    pathname = SITE_PROFILE_ROUTE,
    Name,
    ObjectId,
    personObjectId,
    mode,
    target = "_self",
    children
  } = props;
  return (
    <Link
      to={{
        pathname,
        search: `?params=${JSON.stringify({
          Name,
          ObjectId,
          personObjectId,
          mode
        })}`
      }}
      target={target}
    >
      {children}
    </Link>
  );
};
